module.exports = __webpack_public_path__ + "media/images/sports_coaching/anton-68fa08cbff8f28fd4da4e7b912ad3afa.jpg";